
$(document).ready(function () {
  function normalizePath(path) {
    return path.replace(/\/$/, ''); 
  }

  const currentPath = normalizePath(window.location.pathname);

  // Remove existing active classes
  $('.header__nav a, .mega-menu__wrap a, .footer__item-accordion-content a').removeClass('active');

  // Loop through and match
  $('.header__nav a, .mega-menu__wrap a, .footer__item-accordion-content a').each(function () {
    const href = $(this).attr('href');
    if (!href || href === '#') return;

    const linkPath = normalizePath(href);

    if (currentPath === linkPath || (linkPath !== '/' && currentPath.startsWith(linkPath))) {
      $(this).addClass('active');
    }
  });
});






document.addEventListener("DOMContentLoaded", function () {
    const items = document.querySelectorAll('.journal__item');
    items.forEach((item, index) => {
        const rowIndex = Math.floor(index / 2);
        const positionInRow = index % 2;
        item.style.flex = '';
        if (rowIndex % 2 === 0) {
            item.style.flex = positionInRow === 0 ? '1 0 38.8%' : '1 0 59.2%';
        } else {
            item.style.flex = positionInRow === 0 ? '1 0 59.2%' : '1 0 38.8%';
        }
    });
});



// $(document).ready(function () {
//     let handle = 'all';
//     cardLoad(handle);

// });
// function cardLoad(handle) {
//     let load_card = $(".all-product__items");
//     $.ajax({
//         url: `/collections/${handle}?section_id=collection-card`,
//         type: 'GET',
//         success: function (data) {
//             var html = $(data).find('.all-product__items').html();
//             load_card.html(html)
//         },
//         error: function () {
//             alert('Failed to load products.');
//         }
//     });
// }


//     $('.all-product__top li').on('click', function (e) {
//         e.preventDefault();
//         var handle = $(this).data('collection');
//         $('.all-product__top li').removeClass('active');
//         $(this).addClass('active');
       
//         cardLoad(handle);
//     })




$(document).ready(function () {
    const $tabs = $('.all-product__top li');
    const $itemsContainer = $(".all-product__items");

    function cardLoad(handle) {
        $.ajax({
            // url: `/collections/${handle}?section_id=collection-card`,
            url: `/collections/${handle}?section_id=main-collection`,
            type: 'GET',
            success: function (data) {
                const html = $(data).find('.all-product__items').html();
                $itemsContainer.html(html);
            },
            error: function () {
            }
        });
    }

    function updateURLPath(handle) {
        const newPath = `/collections/${handle}`;
        window.history.pushState({}, '', newPath); // updates the browser path
    }

    // On tab click
    $tabs.on('click', function (e) {
        e.preventDefault();
        const handle = $(this).data('collection');

        // Update active class
        $tabs.removeClass('active');
        $(this).addClass('active');

        // Update URL path
        updateURLPath(handle);

        // Load collection content
        cardLoad(handle);
    });

    // On page load: auto-load correct tab if not already active
    const currentPath = window.location.pathname;
    const collectionHandle = currentPath.split('/collections/')[1];

    if (collectionHandle) {
        const $matchedTab = $tabs.filter(`[data-collection="${collectionHandle}"]`);
        if ($matchedTab.length) {
            $tabs.removeClass('active');
            $matchedTab.addClass('active');
            cardLoad(collectionHandle);
        }
    }


    $('a[href]').each(function () {
        var linkHost = new URL(this.href).hostname;
        var currentHost = location.hostname;

        if (linkHost && linkHost !== currentHost) {
          $(this).attr('target', '_blank');
        }
      });
});




$(".header__search-desktop, .mega-menu__mobi-search").on("click", function (e) {
  e.preventDefault();
  const $search = $(".header__search");
  
  if (!$search.hasClass("open")) {
    $(".overlay").addClass("active")
    $search.addClass("open").css("z-index", "9999999");
    const targetHeight = $search.prop("scrollHeight") + "px";
    $search.css("height", targetHeight);
    $("body").removeClass("menu-active");
  } else {
$(".overlay").removeClass("active")
    $search.css("height", "0").removeClass("open").css("z-index", "-1");
  }
});

$(".header__search-close").on("click", function (e) {
  e.preventDefault();
  const $search = $(".header__search");

  if ($search.hasClass("open")) {
    $(".overlay").removeClass("active");
    $search.css("height", "0").removeClass("open");

    // Wait for the height transition before hiding with z-index
    $search.one("transitionend", function () {
      $search.css("z-index", "-1");
    });
  }
});






  function buildCustomReviews() {
    const jdgmReviews = document.querySelectorAll("#judgeme_product_reviews .jdgm-rev");
    const customContainer = document.querySelector(".review__items");
    if (!jdgmReviews.length || !customContainer) return;

    customContainer.innerHTML = "";

    jdgmReviews.forEach(function(r) {
      const name = r.querySelector(".jdgm-rev__author")?.innerText.trim() || "Anonymous";
      const rating = r.querySelectorAll(".jdgm-star.jdgm-star--on").length;
      const title = r.querySelector(".jdgm-rev__title")?.innerText.trim() || "";
      const body = r.querySelector(".jdgm-rev__body")?.innerText.trim() || "";
      const verified = r.querySelector(".jdgm-rev__buyer-badge") ? "verified" : "";

      let starsHtml = "";
      for (let i = 0; i < rating; i++) {
        starsHtml += `<img src="//drinkamie.com/cdn/shop/t/5/assets/stars.svg?v=104302978684360724191754302331" alt="star">`;
      }

      const item = document.createElement("div");
      item.classList.add("review__item");
      item.innerHTML = `
        <div class="review__item-top">
          <div class="review__item-top-left">
            <h6>${name}</h6>
            <div class="review__stars">${starsHtml}</div>
          </div>
          <div class="review__item-top-right">
            <p>${verified}</p>
          </div>
        </div>
        <div class="review__content">
          <p>${title}</p>
          <p>${body}</p>
        </div>
      `;
      customContainer.appendChild(item);
    });

    // Init/re-init Slick
    if ($(customContainer).hasClass("slick-initialized")) {
      $(customContainer).slick("unslick");
    }
    $(customContainer).slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: false,
      responsive: [
          {
              breakpoint: 768,
              settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
              }
          },
      ]
    });
  }

  // Recursively click "Load more" until all reviews are fetched
  function loadAllReviews() {
    const loadMoreBtn = document.querySelector("#judgeme_product_reviews .jdgm-load-more");
    if (loadMoreBtn) {
      loadMoreBtn.click();
      setTimeout(loadAllReviews, 1500); // wait for AJAX
    } else {
      buildCustomReviews();
    }
  }

  loadAllReviews();
  // document.addEventListener("jdgm.ready", loadAllReviews);


 

  
    const btn = document.querySelector(".review__write-link");
    if (btn) {
      btn.addEventListener("click", function(e) {
        e.preventDefault();
        if (window.jdgm && typeof jdgm.write_review === "function") {
          jdgm.write_review(); // ✅ opens Judge.me review modal
        } else {
          console.warn("Judge.me API still not available");
        }
      });
    }